import { stepActionTypes as act } from './stepActionTypes';

export default function currentStep(state = { initialState: 0 }, action) {
  switch (action.type) {
    case act.INCREMENT: {
      return {
        ...state,
        initialState: action?.payload?.step
          ? state.initialState + action?.payload?.step
          : state.initialState + 1,
      };
    }
    case act.DECREMENT: {
      let stepLvl = state.initialState - 1;
      stepLvl = stepLvl < 0 ? 0 : stepLvl;
      return {
        ...state,
        initialState: stepLvl,
      };
    }
    default:
      return state;
  }
}
